import { render, staticRenderFns } from "./DialogItem.vue?vue&type=template&id=cef6bd24&scoped=true&"
import script from "./DialogItem.vue?vue&type=script&lang=js&"
export * from "./DialogItem.vue?vue&type=script&lang=js&"
import style0 from "./DialogItem.vue?vue&type=style&index=0&id=cef6bd24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef6bd24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/felix/Google Drive/Travail/Clients/syl-vain/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VDatePicker,VDialog,VFlex,VIcon,VImg,VLayout,VProgressCircular,VSpacer,VTextField,VTextarea})
